import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { GridTargetsBase } from '../grid-target-base';
import { getDeviceBasicConfig } from './basic-config';

export const DeviceTargetSetting = React.memo((props) => {
  const i18n = useContext(I18nContext);
  const {
    data, setData, patchErrMsg, patchTargetsApiErrMsg, apiErrors, bidStrategyType, showTargetedColumn,
  } = props;

  const params = {
    ...getDeviceBasicConfig(i18n, bidStrategyType, showTargetedColumn),
    validateParams: { targetId: 'device-target-wrapper', patchErrMsg, targetName: 'device' },
    patchTargetsApiErrMsg,
    apiErrors,
  };

  return (
    <div id="device-target-wrapper">
      <GridTargetsBase data={data} setData={setData} {...params} />
    </div>
  );
}, (prevProps, nextProps) => prevProps.data === nextProps.data && prevProps.bidStrategyType === nextProps.bidStrategyType);

DeviceTargetSetting.propTypes = {
  data: PropTypes.shape({}).isRequired,
  setData: PropTypes.func.isRequired,
  patchErrMsg: PropTypes.func,
  patchTargetsApiErrMsg: PropTypes.func,
  apiErrors: PropTypes.arrayOf(PropTypes.string),
  bidStrategyType: PropTypes.string,
  showTargetedColumn: PropTypes.bool,
};

DeviceTargetSetting.defaultProps = {
  patchErrMsg() { },
  patchTargetsApiErrMsg() { },
  apiErrors: [],
  bidStrategyType: '',
  showTargetedColumn: true,
};
